import { render, staticRenderFns } from "./IframeRace.vue?vue&type=template&id=5305bc04&"
import script from "./IframeRace.vue?vue&type=script&lang=js&"
export * from "./IframeRace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports